<template>
  <main>
    <section class="video-intro">
      <h1>Contrology Event Video</h1>
    </section>

    <nav>
      <router-link to="event-videos" title="See all event videos"><img src="@/assets/icon-standard-arrow-left.svg" alt="Back arrow icon">all videos</router-link>
    </nav>

    <div class="video-container">
      <iframe title="This is an embedded iframe video" width="996" height="560" src="https://www.youtube.com/embed/E-ivqRHOCJg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="wide-flex-wrapper">
      <section class="video-description">
        <h2>Contrology Workout: East Meets West</h2>
        <p>Original Air Date: April 9, 2021</p>
        <p>Asia and Australia meet Los Angeles in this reformer workout led by Sandy Shimoda, also featuring Jihye Kim and Wade Edwell.</p>
        <p>Runtime: 1:27:45</p>
      </section>

      <hr>

      <section class="video-speakers">
        <h3>Featured Speakers</h3>
        
        <div class="video-speaker">
          <img src="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/Sandy@1x.jpg" srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/Sandy@2x.jpg 2x" alt="Sandy headshot">
          <div class="video-speaker-content">
            <p><b>Sandy Shimoda</b></p>
            <p style="white-space:nowrap"><a href="https://vintagepilates.com/">Los Angeles, California</a></p>
          </div>
        </div>

        <div class="video-speakers-container">
          <div class="video-speaker">
            <img src="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/Jihye@1x.jpg" srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/Jihye@2x.jpg 2x" alt="Jihye headshot">
            <div class="video-speaker-content">
              <p><b>Jihye Kim</b></p>
              <p style="white-space:nowrap"><a href="http://poppilatesstudio.com/">Seoul, Korea</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/Wade@1x.jpg" srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/banner/Wade@2x.jpg 2x" alt="Wade headshot">
            <div class="video-speaker-content">
              <p><b>Wade Edwell</b></p>
              <p style="white-space:nowrap"><a href="https://www.thecontrologycoach.com/">Kyneton, Australia</a></p>
            </div>
          </div>

        </div>
      </section>
    </div>
    
  </main>
</template>

<script>
  export default {
    name: "eastmeetswest",

    metaInfo: {
      title: "Classical Pilates Event - East Meets West Contrology Workout",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "In this Contrology Classical Pilates Workout, see mini workout demonstrations from Australia, Asia and the US on various classical pilates apparatus. Start watching now."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/eastmeetswest.jpg"
        }
      ]
    },
  }
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 20px 0 30px;
  max-width: 996px;
  margin: 0 auto;
}

nav a {
  text-transform: uppercase;
  font-family: var(--rob);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  padding: 7px 0;
  display: flex;
  justify-content: flex-start;
}

nav img {
  margin-right: 15px;
}

.video-container { 
  position: relative; 
  padding-bottom: 56.25%; 
  padding-top: 30px; 
  height: 0; 
  overflow: hidden; 
  max-width: 996px;
  margin: 0 auto 40px;
}

.video-container iframe,
.video-container object,
.video-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  max-height: 560px;
}

.video-description p {
  font-size: 0.9375rem;
  line-height: 1.4667;
}

hr {
  border: 0;
  border-top: 1px solid #333;
  width: 100%;
  margin: 30px 0;
}

h3 {
  text-align: left;
}

.video-speakers {
  width: 275px;
  margin: 0 auto;
}

.video-speaker {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.video-speaker img {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 12px;
}

.video-speaker-content p {
  margin: 0 0 10px 0;
}

.video-speaker-content p a {
  color: #000;
}

ol li {
  margin: 10px 0;
}

@media only screen and (max-width:374px) {
  .video-speakers {
    width: 250px;
    margin: -10px
  }
}

@media only screen and (min-width:800px) {
  .video-intro {
    margin: 0 auto;
  }

  .wide-flex-wrapper {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }

  hr {
    display: none;
  }

  .video-description {
    margin-right: 40px;
  }
}

@media only screen and (min-width:955px) {
  .video-intro {
    max-width: 650px;
  }
}

@media only screen and (min-width:1080px) {
  .video-container { 
    padding-bottom: 0;
    height: 560px;
  }
}
</style>